import { GTMProps } from "components/common/GTMProvider";

export type Pages = "retirement" | "family" | "wealth" | "education" | "mortgage";

const gtmPropsMap: Record<Pages, GTMProps> = {
  retirement: {
    form_name: "gcb_retirement-planning-v2",
    product_name: "wealth-insurance_retirement",
  },
  family: {
    form_name: "gcb_family-protection-1-v2",
    product_name: "wealth-insurance_family",
  },
  wealth: {
    form_name: "gcb_wealth-accumulation-1-v2",
    product_name: "wealth-insurance_wealth",
  },
  education: {
    form_name: "gcb_education-planning-1-v2",
    product_name: "wealth-insurance_education",
  },
  mortgage: {
    form_name: "gcb_mortgage-planning-v1",
    product_name: "wealth-insurance_mortgage",
  },
};

export function getGTMProps(page: Pages): GTMProps {
  return gtmPropsMap[page];
}
